let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hpuU9")).then(() => parcelRequire('4o4u4'));